export const GET_ACADEMIES_REQUEST = 'GET_ACADEMIES_REQUEST';
export const GET_ACADEMIES_SUCCESS = 'GET_ACADEMIES_SUCCESS';
export const GET_ACADEMIES_FAILURE = 'GET_ACADEMIES_FAILURE';
